module.exports = __webpack_public_path__ + "static/ZenithSlabDJR-Regular-ce39ddfaf1ad318e5babe70d285b6551.woff";